import React from 'react'
import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import { usePermission } from '@tomfxs/permissions-client'
import RouteContainer from 'src/components/App/RouteContainer'

const EventParticipationList = React.lazy(() => loadComponent('traiwiss', 'ParticipationList'))

export function EventParticipantListRoute() {
    const { academy } = useFlightDeck()

    const canCreate = usePermission('traiwiss.participant.create', { academy: academy?._id! })
    const canDelete = usePermission('traiwiss.participant.delete', { academy: academy?._id! })

    return (
        <RouteContainer>
            <EventParticipationList academyId={academy?._id} canCreate={canCreate} canDelete={canDelete} />
        </RouteContainer>
    )
}
